import { DockyardStatus } from "$types/DockyardStatus";
import { Fiability } from "$types/Fiability";

export const FIABILITY_LABELS = {
  [Fiability.LOW]: "Faible",
  [Fiability.MEDIUM]: "Moyenne",
  [Fiability.HIGH]: "Forte",
};

export const DOCKYARD_STATUS_LABELS = {
  [DockyardStatus.DONE]: "Terminé",
  [DockyardStatus.IN_PROGRESS]: "En cours",
};

export const getDockyardFiabilityOptions = () =>
  Object.keys(FIABILITY_LABELS).map((key) => ({
    value: key,
    label: FIABILITY_LABELS[key],
  }));

export const getDockyardStatusOptions = () =>
  Object.keys(DOCKYARD_STATUS_LABELS).map((key) => ({
    value: key,
    label: DOCKYARD_STATUS_LABELS[key],
  }));
